export const ENV = {
    get encryptionKey(): string {
        return localStorage.getItem("sessionKey") || "";
    },
};